export const TEST_ID = 'onboardingOrganizationCreationPage';

export const ORGANIZATION_NAME_FIELD_NAME = 'name';
